import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div`
  ${tw`max-w-watchesMax mx-auto py-20 px-12 sm:px-24`}
`

export const Main = styled.div`
  max-width: 30rem;
`

export const Body = styled.div`
  * + * {
    margin-top: 1em;
  }
`
